// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";

class Tabs extends Component {

    render() {
        const { t, plan, tab } = this.props;
        return (
            <React.Fragment>
                <div className={`man-sub_header buy ${plan}`}>
                    <div className={tab === 1 ? "active" : ""}>
                        <span>1</span>
                        <span>{t("billing:tab_01.title")}</span>
                    </div>
                    <div className={tab === 2 ? "active" : ""}>
                        <span>2</span>
                        <span>{t("billing:tab_02.title")}</span>
                    </div>
                    <div className={tab === 3 ? "active" : ""}>
                        <span>3</span>
                        <span>{t("billing:tab_03.title")}</span>
                    </div>
                </div>      
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    };
};

const connect_ = connect(
    mapStateToProps
)(Tabs);
export default withTranslation(["order", "inputs", "billing"])(withRouter(connect_));